module.exports = __webpack_public_path__ + "static/img/9.6b5ff6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/sp/9.png
// module id = gxav
// module chunks = 0